export default "__VITE_ASSET__aff61dcc__"